import { render, staticRenderFns } from "./TerminalPricings.vue?vue&type=template&id=78ed6755&"
import script from "./TerminalPricings.vue?vue&type=script&lang=js&"
export * from "./TerminalPricings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports